<template>
  <div v-if="!currentMenu.isShow">
    <section class="common-header" :class="userData.isAndroid
      ? 'padding-nevigate-bar-ANDROID'
      : 'padding-nevigate-bar-IOS'
      " v-if="userData.channel != 'WEB'">
      <div class="row no-gutters">
        <!-- style="margin-right: 0px; !important" -->
        <div class="col-2 justify-content-center align-self-center">
          <div class="" v-if="currentMenu.previousPage != ''" @click="goToPreviousPage()">
            <b-img center :src="iconBack" width="24" height="24"></b-img>
          </div>
        </div>
        <div v-if="currentMenu.previousPage == ''" class="col-8">
          <div class="text-header-center">
            {{ currentMenu.pageName }}
          </div>
        </div>
        <template v-else>
          <div class="col-8 justify-content-center align-self-center">
            <div class="text-header-center">
              {{ currentMenu.pageName }}
            </div>
          </div>
          <div class="col-2"></div>
        </template>

        <div class="col-2 d-flex justify-content-center align-self-center" v-if="currentMenu.previousPage == ''"
          @click="openModalShowBackStep()">
          <b-img width="24" height="24" style="cursor: pointer" :src="imgSystemClose"></b-img>
        </div>
      </div>
    </section>

    <div class="container-lg pr-5 pl-5 mb-4" v-if="userData.channel == 'WEB'">
      <div class="row">
        <div class="col-12">
          <div class="container-lg pr-5 pl-5">
            <div class="bs-stepper linear">
              <div class="bs-stepper-header">
                <div class="step active text-center">
                  <span class="bs-stepper-circle">1</span><br />
                  <span class="bs-stepper-label">เข้าสู่ระบบ</span>
                </div>
                <div class="bs-stepper-line bg-white" v-if="step >= 1"></div>
                <div class="step text-center" v-if="step >= 1" v-bind:class="{ active: step >= 1 }">
                  <span class="bs-stepper-circle">2</span><br />
                  <span class="bs-stepper-label">รายละเอียด</span>
                </div>
                <div class="bs-stepper-line bg-white" v-if="step >= 1"></div>
                <div class="step text-center" v-if="step >= 1" v-bind:class="{ active: step >= 2 }">
                  <span class="bs-stepper-circle">3</span><br />
                  <span class="bs-stepper-label">อัปโหลดเอกสาร</span>
                </div>
                <div class="bs-stepper-line bg-white"></div>
                <div class="step text-center" v-bind:class="{ active: step >= 3 }">
                  <span class="bs-stepper-circle" v-if="step >= 1">4</span>
                  <span class="bs-stepper-circle" v-else>2</span><br />
                  <span class="bs-stepper-label">สรุป</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="modalShowBackStep" hide-header hide-header-close hide-footer content-class="content-dialog-back">
      <div class="justify-content-center">
        <b-row>
          <b-col style="text-align: center"><span
              class="text-ktb-bold-18-black">ยกเลิกการอัปโหลดเอกสาร?</span><br />หากยกเลิก ข้อมูลของคุณจะไม่ถูกบันทึก
            และ<br />ต้องเริ่มต้นเลือกเอกสารใหม่อีกครั้ง</b-col>
          <div class="w-100">
            <hr style="margin-bottom: unset" />
          </div>
        </b-row>

        <b-row align-v="center">
          <b-col style="text-align: center; padding-right: 0px; padding-left: 0px">
            <b-button style="border-right-color: rgb(229 229 229)" class="btn-back-step"
              @click="closeModalShowBackStep()">
              <span class="text-ktb-bold-18-blue">ไม่ใช่</span>
            </b-button>
          </b-col>

          <b-col align-self="baseline" style="text-align: center; padding-right: 0px; padding-left: 0px">
            <b-button style="" class="btn-back-step" @click="goToExitEntryPoint()">
              <span class="text-ktb-bold-18-blue">ใช่</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    currentMenu: Object,
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    step() {
      let step = -1;
      if (this.$route.name.includes("Login")) step = 0;
      else if (this.$route.name.includes("Main")) step = 1;
      else if (
        this.$route.name.includes("Upload") ||
        this.$route.name.includes("ListAccountPage") ||
        this.$route.name.includes("DstatementPage") ||
        this.$route.name.includes("DocumentGroupPage")
      )
        step = 2;
      else if (this.$route.name.includes("Summary")) step = 3;
      return step;
    },
  },

  data() {
    return {
      modalShowBackStep: false,
      imgSystemClose: require("@/assets/images/foundationIconSimpleSystemClose@3x.png"),
      iconBack: require("@/assets/images/Back Arrow Icon.png"),
    };
  },

  methods: {
    goToPreviousPage() {
      let param = this.currentMenu.params;
      if (param != undefined && param.grpId != undefined) {
        this.$router.push({
          name: this.currentMenu.previousPage,
          params: { grpId: param.grpId },
        });
      } else {
        this.$router.push({
          name: this.currentMenu.previousPage,
        });
      }
    },
    goToExitEntryPoint() {
      this.modalShowBackStep = false;
      try {
        this.$callback.exitEntryPoint();
      } catch (err) {
        console.error(err);
      }
    },
    openModalShowBackStep() {
      this.modalShowBackStep = true;
    },
    closeModalShowBackStep() {
      this.modalShowBackStep = false;
    },
  },
};
</script>
<style>
.text-color-NEXT {
  color: #5b6171 !important;
}

.border {
  border: 1px solid #8a8a8a !important;
}

.border-radius-1rem {
  border-radius: 1rem !important;
}

.bg-grey {
  background-color: #fff !important;
}

.text-label {
  color: #727a8d !important;
}

.card-body {
  color: #2f2f2f !important;
}

.badge-info {
  color: #fff;
  background-color: #1ba2de;
}

.b-card-haeder {
  font-weight: bolder;
  font-size: 1rem;
}
</style>
<style scoped>
.bs-stepper-circle {
  color: #17a3de;
  background-color: #5fc2eb;
}

.active .bs-stepper-circle {
  color: #17a3de;
  background-color: #ffffff;
}

.active .bs-stepper-label {
  color: #ffffff;
}

.bs-stepper-label {
  color: #5fc2eb;
}

.text-header-center {
  text-align: center;
  font-size: 20px;
  color: black !important;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
  /* padding-left: 30%; */
}

.icon-back {
  color: #00a7ec;
}

.btn-back-step {
  width: inherit;
  color: #00a3e4;
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius: unset;
}
</style>
